import Cookies from 'grommet/utils/Cookies';
import { said, landingUrl, basename, redirection_Link } from '../../AppConfig';

const initialState = {
  isAuthenticated: undefined,
  userData: {},
  userSettings:{emailNotification:false, isLoading:false}  
};

const authenticationReducer = (state = initialState, action) => {

  switch (action.type) {

    case 'CHECK_LOGIN': {
      return Object.assign({}, state, {
        isAuthenticated: true,
        userData: action.payload,
      });
    }

    case 'FETCH_USER_BUSINESS_INFO_SUCCESS': {
      if (action.payload.UserId === undefined) {
        return Object.assign({}, state, {
          isAuthenticated: false,
          userData: undefined,
          userDataFetchState: 'FETCHED_FAILED'
        });
      }
      return Object.assign({}, state, {        
        userDataFetchState: 'FETCHED_SUCCESS',
        userData: {
          givenname: action.payload.FirstName,
          password: undefined,
          clang: action.payload.CountryLanguage,
          createtimestamp: action.payload.AccountCreationDate,
          email: action.payload.EmailId,
          hpclidnumber: action.payload.UserId,
          hpclname: action.payload.EmailId,
          hpresidentcountrycode: action.payload.CountryCode,
          modifytimestamp: action.payload.AccountModificationDate,
          preferredlanguage: action.payload.PreferredLanguage,
          sn: action.payload.LastName,
        }
      });
    }
    case 'LOGIN_PENDING': {
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while authenticating.'
      });
    }

    case 'FETCH_USER_BUSINESS_INFO_PENDING': {
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while fetching user information.'
      });
    }
    case 'LOGIN_SUCCESS': {
      return Object.assign({}, state, {
        isAuthenticated: true,
        userData: {
          username: action.payload.FirstName,
          password: "",
          clang: action.payload.CountryLanguage,
          createtimestamp: action.payload.AccountCreationDate,
          email: action.payload.EmailId,
          hpclidnumber: action.payload.UserId,
          hpclname: action.payload.EmailId,
          hpresidentcountrycode: action.payload.CountryCode,
          modifytimestamp: action.payload.AccountCreationDate,
          preferredLanguage: action.payload.PreferredLanguage,
          lastName: action.payload.LastName,
          uniqueId:action.payload.UniqueId
        }
      });
    }
    case 'LOGOUT_SUCCESS': {
      let redirectUrl = 'https://cf.passport.hpe.com/hppcf/login.do?hpappid=' + landingUrl + '&applandingpage=https%3A%2F%2F' + redirection_Link + '%2F' + basename.replace('/', '');
      window.location.href = redirectUrl;
      return Object.assign({}, state, {
        isAuthenticated: false,
        userData: undefined,
      });
    }
    case 'LOGOUT_PENDING': {
      return Object.assign({}, state, {
        isLoading: true,
        LoadingMsg: 'Please wait while loging out.'
      });
    }

    case 'LOGOUT': {
      if (Cookies.has('HPPSESSION')) {
        document.cookie = "HPPSESSION=LOGGEDOFF; path=/; domain=.hpe.com; secure";
      }
      //document.cookie = "HPPFEDSESSION=LOGGEDOFF; path=/; domain=.hpe.com;";
      if (Cookies.has('u_d')) {
        document.cookie = "u_d=; path=/; domain=.hpe.com; secure";
      }
      return Object.assign({}, state, {
        isAuthenticated: false,
        userData: undefined,
      });
    }

    case 'LOAD_SELECTION_SUCCESS': {
      if(action.payload.userData && state.userData.hpclname === "default@test.com")
      {
       return Object.assign({}, state, {                
        userData: {
          givenname: action.payload.userData.FirstName,
          password: undefined,                 
          email: action.payload.userData.EmailId,          
          hpclname: action.payload.userData.EmailId,
          hpresidentcountrycode: action.payload.userData.CountryCode,
          modifytimestamp: action.payload.AccountModificationDate,          
          sn: action.payload.userData.LastName,
        }
      })
      }else return state;
    }

    case 'FETCH_SETTINGS_PENDING': {
      return Object.assign({}, state, {
        userSettings: {...state.userSettings,isLoading:true}        
      });
    }

    case 'FETCH_SETTINGS_SUCCESS': {
      return Object.assign({}, state, {
        userSettings: {...state.userSettings,emailNotification:action.payload.EmailNotification,isLoading:false}        
      });
    }

  }

  return state;
};
export default authenticationReducer;



// WEBPACK FOOTER //
// ./src/State/reducers/authentication.js